import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';

export enum AuthenticationType {
  none = 'none',
  code = 'code',
}

export class AuthenticationSettings extends CompanyEntity {
  type: AuthenticationType = AuthenticationType.none;
  expiryInHours: number = 24;
  userId?: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }
}
